<template>


  <div>
    <template v-if="context.parent && context.parent.tag==='subForm'">
      <el-autocomplete v-if="type==='fill'" v-model="value" placeholder="请选择" style="width: 100%" :teleported="true"
                       :fetch-suggestions="querySearch" @select="handleSelect" clearable @clear="data[element.id]=''"
                       :disabled="context.authentication.isDisabled(element,data) || !context.authentication.isWrite(element)"
                       @change="handleChange">
        <template #suffix>
          <el-button v-prevent-re-click icon="Connection" style="font-size: 16px" link
                     @click.stop="handleClick"></el-button>
        </template>
        <template #default="{ item }">
          <div class="value">{{ item.value }}</div>
        </template>
      </el-autocomplete>
      <div v-else-if="type==='detail'">
        <span v-if="value && value==='表单已删除'" style="color: #E57470">{{ value }}</span>
        <span v-else @click="handleClickReferenceForm" style="color: var(--el-color-primary);cursor: pointer">
          {{ value || '⠀' }}
        </span>
      </div>
    </template>

    <el-form-item v-else :required="context.authentication.isRequired(element)">
      <template #label>
      <span :style="{color:'#344262','font-weight':context.form.setting.style.PC.title}">
        {{ element.label }}
        <form-element-tooltip :element="element"></form-element-tooltip>
      </span>
      </template>
      <el-autocomplete v-if="type==='fill'" v-model="value" placeholder="请选择" style="width: 100%" :teleported="true"
                       :fetch-suggestions="querySearch"
                       @select="handleSelect" clearable @clear="data[element.id]=''"
                       :disabled="context.authentication.isDisabled(element,data)" @change="handleChange">
        <template #suffix>
          <el-button v-prevent-re-click icon="Connection" style="font-size: 16px" link
                     @click.stop="handleClick"></el-button>
        </template>
        <template #default="{ item }">
          <div class="value">{{ item.value }}</div>
        </template>
      </el-autocomplete>
      <div v-else-if="type==='detail'" class="design-detail">
        <span v-if="value && value==='表单已删除'" style="color: #E57470">{{ value }}</span>
        <span v-else @click="handleClickReferenceForm" style="color: var(--el-color-primary);cursor: pointer"> {{
            value || '⠀'
          }} </span>
      </div>
    </el-form-item>
    <form-data-select v-if="type==='fill'" ref="formDataSelect" @callback="handleSelect"></form-data-select>
    <app-form-view v-if="type==='detail'" ref="appFormView"></app-form-view>
  </div>


</template>

<script>

import {mapStores} from "pinia";
import {useFlowStore} from "@/stores/flow";
import {useFormStore} from "@/stores/form";
import FormDataSelect from "@/components/common/formDataSelect.vue";
import AppFormView from "@/components/app-form/app-form-view.vue";
import FormElementTooltip from "@/components/common/formElementTooltip.vue";
import {contextFunction} from "@/pojo/script";

export default {
  components: {FormElementTooltip, AppFormView, FormDataSelect},
  props: {
    context: {
      type: Object,
      default: () => {
      }
    },
    element: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      data: {},
      type: '',
      value: '',
      selectSubFormIndex: '',
    }
  },
  computed: {
    ...mapStores(useFlowStore, useFormStore)
  },
  created() {
    this.data = this.context.data;
    this.type = this.flowStore.typeOfElement(this.element, this.context);


    if (this.data[this.element.id]) {
      this.findTitleById(this.data[this.element.id])
    }



    if (this.type === 'fill' && this.element.attrs.defaultFillValue && !this.data[this.element.id]) {
      this.$nextTick(()=>{
        this.data[this.element.id] = this.element.attrs.defaultFillValue;
      })
    }

  },
  mounted() {
    this.$watch(`data.${this.element.id}`, (newVal, oldVal) => {
      if (newVal) {
        this.fill(newVal);
      }

    })

  },
  methods: {
    fill(val) {
      this.findTitleById(val);
      this.formStore.findById(this.element.attrs.form_id, val).then(async res => {
        await this.formStore.referenceFormFill(res.data, this.data, this.element, this.context.form, this.selectSubFormIndex)
      })
    },
    querySearch(queryString, cb) {

      if (this.element.attrs.form_id && (!this.element.attrs.fillRole.mode || this.element.attrs.fillRole.mode === 'default')) {

        this.formStore.referenceForm(this.element.attrs.form_id, queryString, JSON.stringify(this.data), this.context.form.id, this.element.id).then(res => {
          res.data.forEach(item => item.value = Object.keys(item).filter(filter => filter !== 'id').map(mapper => item[mapper]).join(" "))
          cb(res.data);
        })
      } else {
        cb([])
      }

    },
    handleSelect(item, selectSubFormIndex) {
      this.selectSubFormIndex = selectSubFormIndex;
      this.data[this.element.id] = item.id;

      this.handleChange();
    },
    async findTitleById(data_id) {
      if (data_id) {
        this.value = (await this.formStore.findTitleById(this.element.attrs.form_id, data_id)).data;
      }

    },
    handleClick() {

      let params = this.context.parent?.tag === 'subForm' ? _.merge({}, this.data, this.context.rawData) : this.data;


      this.$refs.formDataSelect.call(this.element.attrs.form_id, this.data[this.element.id],
           this.context.parent?.tag!=='subForm' && this.element.attrs.fillRole.subForms.length>0? 'default':this.element.attrs.fillRole.mode,
          {
        //根据当”前行数据“动态筛选关联表单可选项
        dataJson: JSON.stringify(params),
        currentFormId: this.context.form.id,
        currentElementId: this.element.id
      })
    },
    handleClickReferenceForm() {

      if (this.element.attrs.form_id && this.data[this.element.id]) {
        this.$refs.appFormView.call(this.element.attrs.form_id, this.data[this.element.id])
      }

    },
    async handleChange() {
      if (this.element.listen?.script.value) {
        await contextFunction(this.element.listen.script.value, {...this.data, ...(this.context.rawData || {})}, this.context.rawData || this.data);
      }
    },

  }
}

</script>

<style scoped lang="scss">


</style>